const getGrupoCnaeFilterFields = (drops = {}) => [
  { name: 'id', label: 'ID', type: 'number' },
  { name: 'descricao', label: 'Descrição', initial: true },
  {
    name: 'divisao_cnae',
    label: 'Divisão CNAE',
    type: 'select',
    options: drops?.DivisaoCnae,
    multiple: true,
  },
  { name: 'codigo', label: 'Código' },
];

export default getGrupoCnaeFilterFields;
